module.exports = __webpack_public_path__ + "static/media/project-3.8ea1fb58.PNG";